"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PolicyBank = void 0;
const AbstractBatcherBank_1 = require("./base/AbstractBatcherBank");
const PolicyModel_1 = require("../models/PolicyModel");
class PolicyBank extends AbstractBatcherBank_1.AbstractBatcherBank {
    constructor(options) {
        super(options);
    }
    generate(data) {
        return new PolicyModel_1.PolicyModel({
            banks: this.options.banks(),
            clients: this.options.clients,
            model: data
        });
    }
    async fetchCollection(event) {
        var _a;
        const res = this.options.clients.provisionCardinalClient().listPolicies.paginate({
            id: event.items
        });
        for await (let i of res) {
            event.apply((_a = i.items) === null || _a === void 0 ? void 0 : _a.reduce((prev, cur) => {
                return {
                    ...prev,
                    [cur.id]: cur
                };
            }, {}));
        }
    }
    patch(event) {
        event.object.options.model = event.data;
    }
}
exports.PolicyBank = PolicyBank;
